import block from './block.json';

export const formThemeAttributes = {
	margin: {
		top: [24, 48],
		bottom: [24, 48],
	},
	section: {
		margin: {
			top: [45, 90],
		},
		title: {
			color: '@tokens.variants.default.cardTitleColor',
			typography: '@tokens.typographies.heading-4',
			textAlignment: 'left',
		},
	},
	input: {
		margin: {
			bottom: [24, 48],
		},
		padding: {
			top: [9, 9],
			right: [12, 12],
			bottom: [9, 9],
			left: [12, 12],
		},
		backgroundColor: '@tokens.variants.default.cardBackgroundColor',
		border: {
			color: '@tokens.variants.default.cardBorderColor',
			width: {
				top: [1, 1],
				right: [1, 1],
				bottom: [1, 1],
				left: [1, 1],
			},
			radius: {
				topLeft: [0, 0],
				topRight: [0, 0],
				bottomRight: [0, 0],
				bottomLeft: [0, 0],
			},
		},
		typography: '@tokens.typographies.paragraph',
		textAlignment: 'left',
		color: '@tokens.variants.default.cardContentColor',
	},
	label: {
		padding: {
			top: [12, 12],
			right: [12, 12],
			left: [12, 12],
		},
		typography: '@tokens.typographies.paragraph',
		textAlignment: 'left',
		color: '@tokens.variants.default.cardTitleColor',
		optional: {
			typography: '@tokens.typographies.caption',
			textAlignment: 'left',
			color: '@tokens.variants.default.cardTitleColor',
		},
	},
	checkbox: {
		subtitle: {
			typography: '@tokens.typographies.paragraph',
			textAlignment: 'left',
			color: '@tokens.variants.default.titleColor',
		},
		label: {
			typography: '@tokens.typographies.paragraph',
			textAlignment: 'left',
			color: '@tokens.variants.default.cardTitleColor',
		},
	},
	file: {
		backgroundColor: '@tokens.variants.default.cardBackgroundColor',
		border: {
			color: '@tokens.variants.default.cardBorderColor',
			width: {
				top: [1, 1],
				right: [1, 1],
				bottom: [1, 1],
				left: [1, 1],
			},
			radius: {
				topLeft: [0, 0],
				topRight: [0, 0],
				bottomRight: [0, 0],
				bottomLeft: [0, 0],
			},
		},
		padding: {
			top: [12, 25],
			right: [12, 25],
			bottom: [16, 30],
			left: [16, 30],
		},
		title: {
			color: '@tokens.variants.default.cardTitleColor',
			typography: '@tokens.typographies.heading-4',
			textAlignment: 'left',
		},
		description: {
			color: '@tokens.variants.default.cardContentColor',
			typography: '@tokens.typographies.paragraph',
			textAlignment: 'left',
		},
		list: {
			color: '@tokens.variants.default.cardContentColor',
			typography: '@tokens.typographies.paragraph',
			textAlignment: 'left',
		},
		link: {
			color: '@tokens.variants.default.cardtitleColor',
			typography: '@tokens.typographies.paragraph',
			textAlignment: 'left',
		},
		icon: {
			color: '@tokens.variants.default.cardtitleColor',
		},
	},
	select: {
		focused: {
			backgroundColor: '@tokens.variants.default.cardBackgroundColor',
		},
		selected: {
			backgroundColor: '@tokens.variants.default.cardTitleColor',
		},
	},
	error: {
		typography: '@tokens.typographies.paragraph',
		textAlignment: 'left',
		color: '@tokens.variants.default.titleColor',
	},
	success: {
		typography: '@tokens.typographies.paragraph',
		textAlignment: 'left',
		color: '@tokens.variants.default.titleColor',
	},
	states: {
		hover: {}, // adds hover state
	},
};

export const FormThemeControls: ThemeControlsType = {
	// What's displayed
	title: block.title,

	// Unique string/id of the block (= the key used in theme.json)
	slug: block.slug,

	// styling attributes available for this block
	// ...the same way we define attributes for a gutenberg block
	attributes: formThemeAttributes,

	// this renders in the Customizer panel
	// ...the same way "<InspectorControls />" renders in the gutenberg panel
	edit: () => null,
};
